export const site = {
  name: 'Clinton Agada',
  domain: 'clintonagada.dev',
  currentDomain: 'clintonagada.dev',
  title: 'Clinton Agada - Engineer & Founder of Veraclins',
  description:
    'Founder and CEO of Veraclins Tech Solutions, and still hands-on. Nine years building design systems, migrations, editors, and load-bearing software.',
  social: {
    github: 'https://github.com/Veraclins',
    linkedin: 'https://linkedin.com/in/veraclins',
    twitter: 'https://twitter.com/icstps',
  },
  contact: {
    email: 'agadaclinton@gmail.com',
    phone: '+31617480723',
    title: 'Contact - Clinton Agada',
    subtitle:
      'Advisory and consultancy with Clinton Agada: senior engineering judgment by call, or hands-on, senior-led builds.',
  },
} as const;

export const navigation = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/work', label: 'Work' },
  { to: '/contact', label: 'Contact' },
] as const;

export const footerLinks = [
  {
    href: site.social.github,
    label: 'GitHub',
    ariaLabel: 'Visit GitHub profile (opens in new tab)',
  },
  {
    href: site.social.linkedin,
    label: 'LinkedIn',
    ariaLabel: 'Visit LinkedIn profile (opens in new tab)',
  },
  {
    href: site.social.twitter,
    label: 'Twitter',
    ariaLabel: 'Visit Twitter profile (opens in new tab)',
  },
] as const;
